import { useEffect } from "react";
import addform from "./form.module.css";
import { isObject, useFormik } from "formik";
import { useData } from "../../dentistContext/DentistConferenceContext";
import { addItem, updateItem, getAllItems} from "../../../auxiliary/AxiosAPI/AxiosAPI";
import { useMutation,    useQueryClient} from "react-query";

const initialValues = {
  number: "",
  fullname: "",
  email: "",
  phone: "",
  college: "",
};

const validate = (values) => {
  const errors = {};
  if (!values.fullname) {
    errors.fullname = "هذا الحقل مطلوب...";
  } else if (values.fullname.length < 9) {
    errors.fullname = "يجب ان يكون 9 حرفاً أو اكثر";
  }

  if (!values.number) {
    errors.number = "هذا الحقل مطلوب...";
  } else if (values.number.length < 9) {
    errors.number = "يجب أن تكون 9 ارقام على الأقل";
  }

  if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.email)) {
    errors.email = " خطأ في التكوين ...";
  } else if (values.email.length < 9) {
    errors.email = "يجب أن يكون طوله 9 على الأقل";
  }
  return errors;
};

const AddForm = () => {
  const { activeElement, setActiveElement } = useData();
  const queryClient = useQueryClient();


  const formik = useFormik({
    initialValues: !activeElement?initialValues:
      {number:activeElement.number,
      fullname:activeElement.fullname,
      email:activeElement.email,
      phone:activeElement.phone,
      college:activeElement.college,
      },
    validate,
  });

  const updateElement = useMutation({
    mutationFn: updateItem,
    onSuccess:() =>{
    queryClient.invalidateQueries(getAllItems)
    } 
  })
  const addElement = useMutation({
    mutationFn: addItem,
    onSuccess:() => {
    queryClient.invalidateQueries(getAllItems)
    } 
  })
  function isObjectEmpty (obj) {
    return Object.keys(obj).length === 0;
}

  const onSubmit = (e) => {
    e.preventDefault();
    if ((isObjectEmpty(formik.errors)) && formik.values.number.length > 8) {
      if (confirm('هل انت متأكد من هذه المعلومات؟')==true){
        console.log('saving')
        saveElement(formik.values)};
    } else {
      alert('محتوى مخالف للمطلوب!!!\n\n')
    }
    queryClient.invalidateQueries(getAllItems)
  };

  useEffect(() => {
    // set the values for update
    if (activeElement) {
      formik.setTouched({
        number: false,
        fullname: true,
        email: true,
        phone: true,
        college: true,
      });
      formik.setValues(activeElement, true);
    } else {
      formik.setValues(
        {
          number: "",
          fullname: "",
          email: "",
          phone: "",
          college: "",
        },
        false
      );
    }
  }, [activeElement]);

  const saveElement = async (values) => {
    activeElement && activeElement.number
      ? updateElement.mutate({
          id: activeElement.id,
          number: activeElement.number,
          fullname: values.fullname,
          email: values.email,
          phone: values.phone,
          college: values.college,
        })
      :addElement.mutate(values);
    console.log("Information sent...");
  };

  return (
    <>
      <div className={addform.formcontainer}>
        <h1 className={addform.title}>
          {activeElement ? "تعديل معلومات الطالب" : "إضافة مشترك جديد"}
        </h1>
        <form className={addform.formcards} name="form">
          <div className={addform.formcard}>
            <label className={addform.label} htmlFor="number">
              الرقم الجامعي <span className={addform.star}>*</span>
            </label>
            <div className={addform.forminp}>
              <input
                style={{
                  backgroundColor:
                    formik.values.number && !formik.errors.number
                      ? "var(--transparentGreen)"
                      : "var(--transparentRed)",
                }}
                id="number"
                type="text"
                name="number"
                placeholder="9878391666"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.number}
                className={addform.forminputs}
              />
            </div>
            {formik.errors.number && formik.touched.number ? (
              <div className={addform.wpup}>{formik.errors.number}</div>
            ) : null}
          </div>
          <div className={addform.formcard}>
            <label className={addform.label} htmlFor="fullname">
              الإسم <span className={addform.star}>*</span>
            </label>
            <div className={addform.forminp}>
              <input
                style={{
                  backgroundColor:
                    formik.values.fullname &&
                    !formik.errors.fullname &&
                    formik.touched.fullname
                      ? "var(--transparentGreen)"
                      : "var(--transparentRed)",
                }}
                type="text"
                placeholder="الإسم والكنية"
                name="fullname"
                className={addform.forminputs}
                id="fullname"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.fullname}
                lang="ar"
              />
            </div>
            {formik.errors.fullname && formik.touched.fullname ? (
              <div className={addform.wpup}>{formik.errors.fullname}</div>
            ) : null}
          </div>
          <div className={addform.formcard}>
            <label className={addform.label} htmlFor="email">
              البريد الألكتروني <span className={addform.star}>*</span>
            </label>
            <div className={addform.forminp}>
              <input
                style={{
                  backgroundColor:
                    formik.values.email &&
                    !formik.errors.email &&
                    formik.touched.email
                      ? "var(--transparentGreen)"
                      : "var(--transparentRed)",
                }}
                type="email"
                name="email"
                id="email"
                placeholder="abc@gmail.com"
                className={addform.forminputs}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                lang="en"
              />
            </div>
            {formik.errors.email && formik.touched.email ? (
              <div className={addform.wpup}>{formik.errors.email}</div>
            ) : null}
          </div>
          <div className={addform.formcard}>
            <label className={addform.label} htmlFor="phone">
              الهاتف <span className={addform.star}></span>
            </label>
            <div className={addform.forminp}>
              <input
                id="phone"
                type="text"
                name="phone"
                style={{
                  color: formik.values.phone && "black",fontFamily:'var(--English)',direction:'ltr'}}
                placeholder="0234456678"
                className={addform.forminputs}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
              />
            </div>
            <div className={addform.formerrorbar} id="phone_error"></div>
          </div>
          <div className={addform.formcard}>
            <label className={addform.label} htmlFor="college">
              الكلية <span className={addform.star}></span>
            </label>
            <div className={addform.forminp}>
              <select
                name="college"
                id="college"
                value={formik.values.college}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={addform.select}
                placeholder="الجامعة الوطنية الخاصة"
              >
                <option
                  label="اختر كلية"
               >
                  اختر كلية
                </option>
                <option
                  value="1"
                  label="طب الأسنان"
                  style={{
                    color: "var(--blue)",
                    backgroundColor: "var(--yellow)",
                  }}
                >
                  طب الأسنان
                </option>
                <option value="2" label="الصيدلة">
                  الصيدلة
                </option>
                <option value="3" label="العلوم االإدارية والمالية">
                  العلوم االإدارية والمالية
                </option>
                <option value="4" label="الهندسة">
                  الهندسة
                </option>
                <option value="5" label="الهندسة المدنية">
                  الهندسة المدنية
                </option>
                <option value="6" label="هندسة العمارة والتخطيط العمراني">
                  هندسة العمارة والتخطيط العمراني
                </option>
              </select>
            </div>
            <div className={addform.formerrorbar} id="college_error"></div>
          </div>
        </form>
        <div className={addform.buttonsContainer}>
        <button
            onClick={onSubmit}
            type="button"
            id="submit"
            className={addform.formsubmit}
            style={{padding:activeElement?  "0 0.5em": '0 2.5em',display:activeElement?  "inline-block": 'inherit',}}

          >
            {activeElement ? "تعديل المعلومات" : "إضافة مشترك"}
          </button>
          <button
            onClick={() => {
              setActiveElement(null)}}
              type="button"
            id="submit"
            className={addform.formsubmit}
            style={{display:activeElement?  "inline-block": 'none',
                    padding:activeElement?  "0": 'inherit'
          }}
          >
            {activeElement ?"--->" : "" }
          </button>
        </div>
      </div>
    </>
  );
};
export default AddForm;
